import { Component, Inject, Optional } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/operators';
import { AllSamplesGroupModel } from 'src/app/models/all-samples-group-model';
import { PageModel } from 'src/app/models/page-model';
import { PinType } from 'src/app/models/pinType';
import { SampleGroupInfo } from 'src/app/models/Sample-Group-Info';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { GroupService } from 'src/app/services/group.service';
import { PinManagerService } from 'src/app/services/pin-manager.service';
import dayjs from "dayjs";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UpdateGroupComponent } from '../../update-group/update-group.component';
import { DeleteSampleGroupComponent } from '../../delete-sample-group/delete-sample-group.component';
import { Location } from '@angular/common';
@Component({
  selector: 'app-retrieve-pin-gridding',
  standalone: false,
  templateUrl: './retrieve-pin-gridding.component.html',
  styleUrl: './retrieve-pin-gridding.component.css',
})
export class RetrievePinGriddingComponent {


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public nav: NavBarComponent,
      private groupService: GroupService,
      private pinManagerService: PinManagerService,
      public dialogRef: MatDialogRef<RetrievePinGriddingComponent>,
      public editGroupDialog: MatDialog,
      public deleteGroupDialog: MatDialog,
      private location: Location
    
    ){
      // Handle backdrop click to close dialog directly without save prompt
      this.dialogRef.backdropClick().subscribe(() => {
        this.forceClearEditingStates();
        this.dialogRef.close({ action: 'cancel' });
      });

      // Handle escape key to close dialog directly without save prompt  
      this.dialogRef.keydownEvents().subscribe(event => {
        if (event.key === 'Escape') {
          this.forceClearEditingStates();
          this.dialogRef.close({ action: 'cancel' });
        }
      });
  }

      currentPage: number = 0;
      pageSize: number = 25;
      totalElements: number = 0;
      // tableHeightDifference: number = 470;
      // pinType: PinType;
      // pintypeId: string = '0';
      groupId: number = 0;
      tenantId: string = null;
      searchValue: string = null;
      groupInfo: PageModel<SampleGroupInfo[]>;
      fillteredGroups: SampleGroupInfo[] = [];
      dataSource = new MatTableDataSource<AllSamplesGroupModel>([]);
      isNoItemsFound: boolean = false;

      dayjs = dayjs; 
      currentDate = dayjs().format('YYYY-MM-DD');
      dateStringFormatting = 'YYYY-MM-DD';

    ngOnInit(){
      this.populateGriddingSampleGroupList();
    }

   close(): void {
    // Clear any potential editing states that might trigger save dialog
    // Force close without any save prompts
    this.forceClearEditingStates();
    this.dialogRef.close({ action: 'cancel' });
  }

  private forceClearEditingStates(): void {
    // Try to access the field component and clear all editing states
    try {
      // Clear any global editing flags that might exist
      if ((window as any).fieldComponent) {
        const fieldComp = (window as any).fieldComponent;
        fieldComp.editing = false;
        fieldComp.saveField = false;
        fieldComp.saveEditedField = false;
        fieldComp.saveEditedArea = false;
        fieldComp.oneAction = false;
        fieldComp.editingArea = false;
        fieldComp.editingField = false;
      }
    } catch (error) {
      // Ignore any errors - just proceed with closing
      console.debug('Could not clear editing states:', error);
    }
  }

    openDeleteGroupDialog(group: SampleGroupInfo) {

        const dialogRef = this.deleteGroupDialog.open(DeleteSampleGroupComponent, {

            data: {
                bulkDelete: false,
                groupId: group?.id
            }
        });

        dialogRef.afterClosed().subscribe(result => {

            if (result.option === 'delete') {
               this.dialogRef.close();
            }
        });
    }


  editGroup(group: SampleGroupInfo){
    // edit group name - perhaps more detail required
  }

      openEditGroupDialog(group: SampleGroupInfo) {

        console.log(group, 'group info');
  
          const dialogRef = this.editGroupDialog.open(UpdateGroupComponent, {
  
              data: {
                  group: group
              }
          });
  
          dialogRef.afterClosed().subscribe(groupName => {
  
              if (groupName) {
                  group.name = groupName;
              }
          });
      }

  viewHistory(group: SampleGroupInfo){

    //PASS required detail from groupitem to field component then close dialog 
this.dialogRef.close({
        action: 'loadGrid',
        gridConfig: {
            gridSpacing: group.gridSpacing,
            gridRotation: group.gridRotation
        },
        groupId: group?.id,
        groupName: group?.name,
        isGrid: group?.isGrid,
    });
    // console.log(group, 'view group');  
  }

      populateGriddingSampleGroupList() {
          this.nav.toggleLoading(true);
  
          // const farmId: number = Number(sessionStorage.getItem('lastFarmId'));
          const  fieldId = this.data?.fieldId;

          // console.log(fieldId, 'f id');

          this.groupService.getPaginatedGroupGriidingListByFieldId(
              fieldId,
              this.currentPage,
              this.pageSize,
              this.currentDate
          ).pipe(
              catchError(error => {
                  console.error();
                  return throwError(() => error);
              })
          ).subscribe((response) => {
               this.fillteredGroups = response?.content.filter(group => group?.isGrid === true);

              //  console.log(this.fillteredGroups, 'filtered groups')
              this.nav.toggleLoading(false);
          });
  
      }

      // setGridPinDetails(smapleGroupId: number) {
      //     this.nav.toggleLoading(true);

      //     this.groupService.getHistoricPinDetailsForGriidingBySampleGroupId(smapleGroupId).pipe(
      //         catchError(error => {
      //             console.error();
      //             return throwError(() => error);
      //         })
      //     ).subscribe((response) => {
      //         //  console.log(response, 'sample group pin info');
              
      //         //  console.log(this.fillteredGroups, 'filtered groups')
      //         this.nav.toggleLoading(false);
      //     });
  
      // }
}
